<template>
  <v-container class="pa-0">
    <v-row
      no-gutters
      align="center"
    >
      <v-col cols="3">
        <v-img
          class="ma-0 mr-3"
          aspect-ratio="1"
          :src="accountInfo.img"
        />
      </v-col>
      <v-col
        cols="9"
        class="text-left"
      >
        <div class="d-flex align-center mb-2">
          <div
            class="font-weight-bold"
            style="font-size: 20px"
          >
            {{ accountInfo.accountName }}
          </div>
        </div>
        <div>{{ accountInfo.address }}</div>
        <div>{{ accountInfo.mobile }}</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    accountInfo: {
      type: [Object],
      default: null
    }
  }
}
</script>

<style scoped>

</style>
